<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
        <div slot="content">
            <div class="btn-type1">
                <el-button size="mini" type="primary" icon="el-icon-search" @click="goOpen">
                    {{ this.$i18n.messages[this.$store.state.locale].search }}
                </el-button>
            </div>
            <div class="pop-content-search">
              <el-form size="mini" label-width="75px">
                <el-row :gutter="24">
                  <el-col :span="7">
                    <el-form-item label="고객구분">
                      <el-select v-model="form.siteType">
                        <el-option
                            v-for="item in combos['siteType']"
                            :key="item.value"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="17">
                    <el-form-item label="사이트명">
                      <el-row>
                        <el-col :span="8">
                          <el-input type="text" v-model="form.siteNm1"></el-input>
                        </el-col>
                        <el-col :span="8">
                          <el-input type="text" v-model="form.siteNm2"></el-input>
                        </el-col>
                        <el-col :span="8">
                          <el-input type="text" v-model="form.siteNm3"></el-input>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div class="table-area">
                <div class="table-b">
                    <ag-grid-vue 
                        style="width: 100%; height: 320px;"
                        class="ag-theme-alpine"    
                        row-selection="single"
                                
                        :column-defs="columnDefs"     
                        :grid-options="gridOptions"
                        :row-data="rowData"
                        :default-col-def="defaultColDef"
                        :statusBar="statusBar"
                        @rowDoubleClicked="rowDoubleClick"
                        @grid-ready="onGridReady"
                        @cell-clicked="onCellClicked" />
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';

/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
    props: {
        tabData: {
            Type: Array
            , required: false
        },
        custNo: {
            Type: String
            , required: false
        }
    },
    components: {Layout, AgGridVue},
    data() {
        return {
          title: '사이트선택',
          // AG-GRID OPTION [START]
          rowData:[],
          gridOptions: {},
          form: {
            companyId : '',
            siteType : '',
            siteNm1 : '',
            siteNm2 : '',
            siteNm3 : '',
            catId : '',
            maYn : '',
            payYn : '',
            cyberRommId : '',
            sortType : '',
            page : 1,
            totalPage : 99999,
            curPage : 0,
            totalCount : 99999,
            processTime : ''
          },
          combos: {
            'siteType' : []
          },
          columnDefs:[
              {headerName: '고객구분', width:120, field:'siteTypeNm', cellStyle:{textAlign: 'center'}},
              {headerName: '사이트명', width:200, field:'siteNms', cellStyle:{textAlign: 'left'},
                valueGetter: (params) => {
                  return params.data.siteNm1 + ' ' + params.data.siteNm2 + ' ' + params.data.siteNm3
                }},
              {headerName: '주소', width:200, field:'addrNms', cellStyle:{textAlign: 'left'},
                valueGetter: (params) => {
                  return params.data.addr1 !== '' ? params.data.addr1 + params.data.addr2 : params.data.addr2
                }},
              {headerName: '고객명', width:120, field:'chargeNm', cellStyle:{textAlign: 'center'}},
              {headerName: '핸드폰', width:120, field:'hpNo', cellStyle:{textAlign: 'center'}},
              {headerName: '지정센터', width:140, field:'asAgentNm'}
          ],
          defaultColDef: {
              resizable: true,
              filter:true,
              sortable: true
          },
          statusBar: null,
        }
    },
    mounted() {
        // this.form = this.tabData[0] ? this.tabData[0].param : {}
    },
    created() {
      this.statusBar = {
        statusPanels: [
          { statusPanel: 'agTotalRowCountComponent', align: 'right' },
        ],
      };
    },
    methods: {
        closeModal() {
            this.$parent.close();
        },
        onGridReady(){
            this.getCombo({flag: 'INIT'})
        },
        rowDoubleClick(params){
            this.$emit('close', params.data);
        },
        onCellClicked(event) {
            console.log('add onCellClicked  start===', event)
            this.$emit('close', event);
            this.closeModal();
        },
        getCombo(param) {
            if(param.flag === 'INIT'){
                // 고객구분
              this.getSiteType();
            } else {
            }
        },
        goOpen(){
            this.$store.commit('loading')
            const vform = {
              companyId: this.$store.state.loginInfo.compCd,
              siteType: this.form.siteType,
              siteNm1: this.form.siteNm1,
              siteNm2: this.form.siteNm2,
              siteNm3: this.form.siteNm3,
              maYn: this.form.maYn,
              payYn: this.form.payYn,
              cyberRoomId: this.form.cyberRommId,
              catId : 0,
              sortType : this.form.sortType,
              page : this.form.page,
              totalPage : this.form.totalPage,
              curPage : this.form.curPage,
              totalCount : this.form.totalCount,
              processTime : this.form.processTime
            }
            this.$http.post(("/api/siteMng/list"), vform)
                .then(response => {
                  this.rowData = response.data;
                  console.log(this.rowData);
                  /* data customize */
                  this.changeData();
            }).finally(() => {
                this.$store.commit('finish')
            });
        },
        getSiteType(){
          this.$http.get(`/api/codeMng/combo`, { params: {parentId: 10} })
              .then(response => {
                this.combos['siteType'] = response.data || []
                this.combos['siteType'] .unshift({key:'', value:'전체'})
              });
        },
        /* data customize */
        changeData(){
          this.rowData.map((x, i) => {
            let filterSiteType = this.combos['siteType'].filter(y => y.key === x.siteType);
            x.siteTypeNm = filterSiteType[0].value;
          })
        }
    }
}
</script>

<style lang="scss" scoped>
// .modal-card {
//   width: 970px;
// }

// .display-area {
//   :global(img) {
//     width: 100%;
//   }
// }
</style>